import React, { Component } from 'react';
import PropTypes from 'prop-types';
import CustomModal from '../../../shared/components/Modal';
import { withTranslation } from "react-i18next";

class ConfirmRemoveModal extends Component {
    static propTypes = {
        isOpen: PropTypes.bool,
        onAccept: PropTypes.func.isRequired,
        onClose: PropTypes.func.isRequired
    };

    render() {
        const {t} = this.props;
        return (
            <CustomModal
                isOpen={this.props.isOpen}
                onAccept={this.props.onAccept}
                onClose={this.props.onClose}
                color="danger"
                title={t('modals.delete.title')}
                colored
                cancelButtonText={t('modals.delete.buttons.cancel')}
                okButtonText={t('modals.delete.buttons.ok')}
                message={t('modals.delete.body')}
            />
        );
    }
}

export default withTranslation('dashboard')(ConfirmRemoveModal);
